// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"0306b2ed","453":"138c0ec8","508":"1e9527b2","776":"db3fc5ae"}[chunkId] + ".chunk.js";
};